import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { ScrollText } from "lucide-react";
import { toast } from "sonner";

function formatDateTime(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("it-IT", { timeZone: "Europe/Rome" }); } catch { return iso; }
}

export default function MasterAudit() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/master/audit").then(r => setRows(r.data)).catch(e => toast.error(formatApiError(e)));
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-wider text-amber-400 font-semibold">Sicurezza</div>
        <h1 className="font-heading text-3xl font-bold">Audit log</h1>
        <p className="text-sm text-slate-400 mt-1">Tracciatura di tutte le azioni master (impersonation, modifiche, reset).</p>
      </div>
      <Card className="bg-slate-900 border-slate-800 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-slate-800/60 text-left">
                <th className="px-4 py-3 text-[10px] font-semibold uppercase tracking-wider text-slate-400">Data/ora</th>
                <th className="px-4 py-3 text-[10px] font-semibold uppercase tracking-wider text-slate-400">Azione</th>
                <th className="px-4 py-3 text-[10px] font-semibold uppercase tracking-wider text-slate-400">Eseguita da</th>
                <th className="px-4 py-3 text-[10px] font-semibold uppercase tracking-wider text-slate-400">Agenzia / utente target</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800">
              {rows.length === 0 && <tr><td colSpan={4} className="text-center text-slate-400 py-8"><ScrollText className="w-6 h-6 mx-auto mb-2 text-slate-600" />Nessuna azione registrata</td></tr>}
              {rows.map(r => (
                <tr key={r.id}>
                  <td className="px-4 py-3 text-slate-300 font-mono text-xs">{formatDateTime(r.at)}</td>
                  <td className="px-4 py-3"><span className="text-amber-300 font-semibold">{r.action}</span></td>
                  <td className="px-4 py-3 text-slate-300">{r.by_username}</td>
                  <td className="px-4 py-3 text-slate-400 text-xs font-mono">{r.agency_id?.slice(0, 8)} / {r.target_user_id?.slice(0, 8)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
